import sanitizeHtml from 'sanitize-html';
import { quillClasses } from './constants';

export const quillSanitizeOptions = {
  allowedTags: ['strong', 'em', 'u', 'span'],
  allowedAttributes: {
    '*': ['class'],
    span: ['data-*']
  },
  allowedClasses: {
    strong: quillClasses,
    em: quillClasses,
    u: quillClasses,
    span: quillClasses
  },
  allowedSchemes: ['http', 'https', 'mailto', 'tel'],
  transformTags: {
    b: 'strong',
    i: 'em'
  },
  // Remove empty tags
  exclusiveFilter: frame => !frame.attribs['data-key'] && !frame.text
};

export function quillSanitize(value) {
  value = sanitizeHtml(value || '', quillSanitizeOptions);
  return value;
}

export function quillFormat(value) {
  value = value || '';
  if (!value.startsWith('<p>') && !value.startsWith('<p ')) {
    value = '<p>' + value;
  }
  if (!value.endsWith('</p>')) {
    value += '</p>';
  }
  return value;
}



// WEBPACK FOOTER //
// ./src/utils/quill/functions.js